import React from 'react';

/* mui */
import Grid from '@material-ui/core/Grid';
/* mui */

const wrapper = props => {
  return <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
    { props.children }
  </Grid>
}

export default wrapper;
